<script>
  import { createEtherscanLink } from "../util/constants";
  import { shortAddress } from "../util/shortAddress";
  import ExternalLink from "./ExternalLink.svelte";

  export let type = "address";
  export let fragment = "";
</script>

<ExternalLink truncate href={createEtherscanLink({ type, fragment })}
  >{shortAddress(fragment)}</ExternalLink
>
